import * as React from 'react';
import { ScoringSettings } from '../../../../sdk/model';
import { Card, CardHeader, CardContent, Grid, Typography, TextField } from '@mui/material';

interface otherSettingsProps {
  scoringSettings: ScoringSettings,
  editing: boolean,
  handleChange: Function
}

function OtherSettings(props: otherSettingsProps) {
  return <Card sx={{ border: 1, width: 600 }}>
    <CardHeader sx={{paddingBottom: 0}}
        title={<Typography variant="h4" component="div" color="text.secondary" sx={{ flexGrow: 1 }}>
         Other
       </Typography>}>
    </CardHeader>
    <CardContent>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <TextField name="points" label="Fumbles" value={props.scoringSettings?.fumbles.points} type="number"
              onChange={event => props.handleChange(event, "fumbles")} disabled={!props.editing} />
        </Grid>
        <Grid item xs={6}>
          <TextField name="kickoffReturnTds" label="Kickoff Return TDs" value={props.scoringSettings?.specialTeamsSettings.kickoffReturnTds.points} type="number"
              onChange={event => props.handleChange(event, "specialTeamsSettings")} disabled={!props.editing} />
        </Grid>
        <Grid item xs={6}>
                  <TextField name="puntReturnTds" label="Punt Return TDs" value={props.scoringSettings?.specialTeamsSettings.puntReturnTds.points} type="number"
                      onChange={event => props.handleChange(event, "specialTeamsSettings")} disabled={!props.editing} />
                </Grid>
      </Grid>
    </CardContent>
  </Card>
}

export default OtherSettings;
